(function () {
  const REF_SOURCE_ID = 'ref_source_id';
  const REF_TOKEN = 'ref_token';
  const REF_TYPE = 'ref_type';
  function getRegistryProperties() {
    const refSourceId = sessionStorage.getItem(REF_SOURCE_ID);
    const refToken = sessionStorage.getItem(REF_TOKEN);
    const refType = sessionStorage.getItem(REF_TYPE);
    if (!refSourceId) return null;
    const props = {};
    if (refType) props['_ref_type'] = refType;
    if (refSourceId) props['_ref_source_id'] = refSourceId;
    if (refToken) props['_ref_token'] = refToken;
    return props;
  }
  function injectProperties(body) {
    const props = getRegistryProperties();
    if (!props) return body;
    // body 是 FormData
    if (body instanceof FormData) {
      const fd = new FormData();
      for (const pair of body.entries()) fd.append(pair[0], pair[1]);
      for (const key in props) {
        if (!fd.has(key)) fd.append(key, props[key]);
      }
      return fd;
    }
    // body 是 JSON string
    if (typeof body === 'string') {
      try {
        const obj = JSON.parse(body);
        obj.properties = Object.assign({}, obj.properties, props);
        return JSON.stringify(obj);
      } catch (e) {}
    }
    // body 是普通对象
    if (body && typeof body === 'object') {
      body.properties = Object.assign({}, body.properties, props);
      return body;
    }
    return body;
  }
  // 拦截 fetch
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;
    if (url && url.indexOf('/cart/add') !== -1) {
      init = init || {};
      init.body = injectProperties(init.body);
    }
    return _fetch.apply(this, arguments);
  };
  // 拦截 XHR（兼容老主题）
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this._url && this._url.indexOf('/cart/add') !== -1) {
      body = injectProperties(body);
    }
    return _send.call(this, body);
  };
  // 兼容 form submit（原有逻辑保留）
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-atc-form]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var props = getRegistryProperties();
      if (!props) return;
      form
        .querySelectorAll('[name="properties[_ref_type]"],[name="properties[_ref_source_id]"],[name="properties[_ref_token]"]')
        .forEach(function (el) {
          el.remove();
        });
      for (var key in props) {
        var el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[' + key + ']';
        el.value = props[key];
        form.appendChild(el);
      }
    },
    true,
  );
})();
